let $b4e14b6b8da86996$var$slideshow = document.querySelectorAll("#pics");
let $b4e14b6b8da86996$var$displayed = 0;
let $b4e14b6b8da86996$var$vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
let $b4e14b6b8da86996$var$vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
function $b4e14b6b8da86996$var$reload() {
    let n = 0;
    for (let gallery of $b4e14b6b8da86996$var$slideshow){
        n = gallery.children.length;
        for (let child of gallery.children)child.style.display = "none";
        gallery.children[($b4e14b6b8da86996$var$displayed % n + n) % n].style.display = "block";
    }
}
function $b4e14b6b8da86996$var$setAllStyle(style, width, query) {
    let elems = document.querySelectorAll(query);
    for (let element of elems)element.style[style] = width;
}
document.addEventListener("DOMContentLoaded", (_)=>{
    if ($b4e14b6b8da86996$var$vw > $b4e14b6b8da86996$var$vh) {
        $b4e14b6b8da86996$var$setAllStyle("width", "30vw", ".right");
        $b4e14b6b8da86996$var$setAllStyle("height", "80vh", ".left");
        $b4e14b6b8da86996$var$setAllStyle("width", "30vw", "img");
        $b4e14b6b8da86996$var$setAllStyle("width", "30vw", ".walign");
    } else {
        $b4e14b6b8da86996$var$setAllStyle("width", "80vw", ".right");
        $b4e14b6b8da86996$var$setAllStyle("width", "80vw", "img");
        $b4e14b6b8da86996$var$setAllStyle("width", "80vw", ".walign");
    }
    $b4e14b6b8da86996$var$reload();
});
setInterval(()=>{
    $b4e14b6b8da86996$var$reload();
    $b4e14b6b8da86996$var$displayed++;
}, 1500);


//# sourceMappingURL=index.93167661.js.map
